<h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
  <div fxFlex>Switch To Selected Company</div>
  <button mat-icon-button [mat-dialog-close]="'close'" class="button-40">
    <mat-icon>close</mat-icon>
  </button>
</h1>

<mat-dialog-content class="mat-typography">
  <div fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="10px">
    <button *ngFor="let company of companies" mat-stroked-button type="button" (click)="onCompanySelect(company)">{{company.profileName}}</button>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="closeSendConfirmPopup('close')">Close</button>
</mat-dialog-actions>
